import React, { Component } from "react";
import pro_pic_1 from "../img/profile-pic3.png";
import { FaLinkedin, FaTwitter, FaGithub, FaEnvelope } from "react-icons/fa";

class About extends Component {
  constructor(props) {
    super(props);

    this.about = props.about;
  }

  render() {
    return (
      <section className="section-about" id="about">
        <div className="u-center-text u-margin-bottom-big--about">
          <h2 className="heading-secondary">About</h2>
        </div>

        <div className="row">
          <div className="col-1-of-2">
            <div className="composition">
              <img
                className="composition__photo composition__photo--p1"
                src={pro_pic_1}
                alt="profile"
              />
            </div>
            <div className="composition__social">
              <ul className="composition composition_list">
                <li className="composition__item">
                  <a
                    href="https://linkedin.com/in/jackson-thapelo-moji-5515167a"
                    className="composition__link"
                  >
                    <FaLinkedin />
                  </a>
                </li>
                <li className="composition__item">
                  <a
                    href="mailto:jacksonmoji@gmail.com"
                    className="composition__link"
                  >
                    <FaEnvelope />
                  </a>
                </li>
                <li className="composition__item">
                  <a
                    href="https://twitter.com/jacksonmoji"
                    className="composition__link"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li className="composition__item">
                  <a
                    href="https://github.com/jacksonmoji"
                    className="composition__link"
                  >
                    <FaGithub />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-1-of-2">
            <h3 className="heading-tertiary u-margin-bottom-small">
              Jackson Thapelo Moji
            </h3>

            <p className="paragraph">
            I am a versatile software engineer looking for great opportunities in the industry to work in projects as a back-end engineer. I have been building hands-on experience spanning 2+ years developing software for various companies offering services to clients in Service marketplace, Insurance and Commerce industries. Always eager to learn new Technologies and find interesting ways of solving problems.

            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
